import { KONG_SERVICE_NAME_ANNOTATION, KONG_SERVICE_SPEC_ANNOTATION } from '../utils/constants/kongAnnotations.esm.js';

const isKongServiceManagerAvailable = (entity) => !!entity.metadata.annotations?.[KONG_SERVICE_NAME_ANNOTATION];
const isKongManagerSpecAvailable = (entity) => !!entity.metadata.annotations?.[KONG_SERVICE_SPEC_ANNOTATION];

export { isKongManagerSpecAvailable, isKongServiceManagerAvailable };
//# sourceMappingURL=useKongServiceManager.esm.js.map
